const dictionary = {
  layout: {
    siteHeader: {
      'menu-item-multipass': 'Multipass',
      'menu-item-account': 'My Account',
      'menu-item-support': 'Support'
    },

    sidebar: { 'button-toggler-ariaLabel': 'Toggle the sidebar' }
  },

  pages: {
    error: {
      401: {
        'document-title': 'Unauthorized',
        'document-desc': '',
        'main-heading': '401 - Unauthorized',
        'page-content': 'You are not allowed to access this page without logging in.'
      },

      404: {
        'document-title': 'Page not found',
        'document-desc': '',
        'main-heading': '404 - Not found',
        'page-content': 'The page content you were looking for could not be found.'
      },

      500: {
        'document-title': 'Error occurred',
        'document-desc': '',
        'main-heading': 'Something went wrong',
        'page-content': 'Try again later.'
      }
    }
  },

  elements: {
    editableText: { 'message-success': '{inputLabel} updated successfully' },

    editorControl: {
      'button-edit': 'Edit',
      'button-edit-ariaLabel': 'Edit {ariaEditorName}',
      'button-closer': 'Cancel',
      'button-closer-ariaLabel': 'Cancel changes',
      'button-submit': 'Save',
      'button-submit-ariaLabel': 'Save changes'
    },

    customDayPicker: {
      'controller-button-month-next-ariaLabel': 'Next month',
      'controller-button-month-prev-ariaLabel': 'Previous month',
      'navbar-button-month-prev-ariaLabel': 'Go to previous month ({monthNamePrev})',
      'navbar-button-month-next-ariaLabel': 'Go to previous year ({yearPrev})',
      'navbar-button-year-prev-ariaLabel': 'Go to next month ({monthNameNext})',
      'navbar-button-year-next-ariaLabel': 'Go to next year ({yearNext})'
    },

    customInput: {
      'passwordMeter-ariaLabel': 'Your password is {strength}',
      'passwordMeter-strength-min': 'Unacceptable',
      'passwordMeter-strength-low': 'Very weak',
      'passwordMeter-strength-mid': 'Weak',
      'passwordMeter-strength-high': 'Good',
      'passwordMeter-strength-max': 'Strong',
      'input-date-button-dropdown-ariaLabel': 'Toggle the date picker dropdown'
    },

    menu: { 'button-toggler-ariaLabel': 'Toggle menu' },

    loader: { 'text-loading': 'Loading' },

    hugeStatusIndicator: {
      'text-pending': 'Pending',
      'text-success': 'Success',
      'text-error': 'Error'
    }
  },

  lists: {
    systemMessages: {
      'list-ariaLabel': 'System messages',
      'list-item-ariaLabel': 'System message',
      'list-item-button-dismiss-ariaLabel': 'Dismiss this message',
      'text-ariaLabel-success': 'Success: {message}',
      'text-ariaLabel-info': 'Information: {message}',
      'text-ariaLabel-warning': 'Warning: {message}',
      'text-ariaLabel-error': 'Error occurred: {message}'
    }
  },

  general: {
    messages: {
      'error-general': 'Something went wrong',
      'error-input-empty': 'The {fieldName} field must be filled',
      'error-input-format': 'The format of the {fieldName} field is invalid',
      'error-input-email-format': 'The provided email format is invalid',
      'error-input-password-weak': 'This password is too weak and can easily be guessed by attackers',
      'error-input-unmatch':
        "The input value of {thisFieldName} field does not match with {comparedFieldName}'s",
      'error-input-long': 'This value is too long - only {maxLength} characters are allowed',
      'prompt-leavingDirtyForm':
        'You have already filled some of the inputs whose data will be lost if you abandon the form. '
        + 'Are you sure you want to proceed?'
    },

    dates: {
      'month-1': 'January',
      'month-2': 'February',
      'month-3': 'March',
      'month-4': 'April',
      'month-5': 'May',
      'month-6': 'June',
      'month-7': 'July',
      'month-8': 'August',
      'month-9': 'September',
      'month-10': 'October',
      'month-11': 'November',
      'month-12': 'December',
      'day-1': 'Monday',
      'day-2': 'Tuesday',
      'day-3': 'Wednesday',
      'day-4': 'Thursday',
      'day-5': 'Friday',
      'day-6': 'Saturday',
      'day-7': 'Sunday'
    },

    units: {
      'piece-short': 'pcs.'
    }
  }
};

export default dictionary;